import { GET_PROMOTION_SETTINGS_REQUEST, GET_PROMOTION_SETTINGS_SUCCESS, GET_PROMOTION_SETTINGS_FAILURE, UPDATE_PROMOTION_SETTINGS_REQUEST, UPDATE_PROMOTION_SETTINGS_SUCCESS, UPDATE_PROMOTION_SETTINGS_FAILURE, GET_PROMO_CODES_REQUEST, GET_PROMO_CODES_SUCCESS, GET_PROMO_CODES_FAILURE } from '../constants';
import { promotionService } from '../services/promotion.services';

export default {
  getSettings,
  updateSettings,
  getCodes
};

function errorMessage(error) {
  return (error && error.error) || 'Something went wrong.';
}

function getSettings() {
  return dispatch => {
    dispatch(request());

    promotionService.getSettings()
      .then(
        data => dispatch(success(data.settings)),
        error => dispatch(failure(errorMessage(error)))
      );
  };

  function request() { return { type: GET_PROMOTION_SETTINGS_REQUEST } }
  function success(settings) { return { type: GET_PROMOTION_SETTINGS_SUCCESS, settings } }
  function failure(error) { return { type: GET_PROMOTION_SETTINGS_FAILURE, error } }
}

function updateSettings(settings) {
  return dispatch => {
    dispatch(request(settings));

    promotionService.updateSettings(settings)
      .then(
        data => {
          dispatch(success(data.settings));
        },
        error => {
          dispatch(failure(errorMessage(error)));
        }
      );
  };

  function request(settings) { return { type: UPDATE_PROMOTION_SETTINGS_REQUEST, settings } }
  function success(settings) { return { type: UPDATE_PROMOTION_SETTINGS_SUCCESS, settings } }
  function failure(error) { return { type: UPDATE_PROMOTION_SETTINGS_FAILURE, error } }
}

function getCodes(criteria) {
  return dispatch => {
    dispatch(request());

    promotionService.getCodes(criteria)
      .then(
        codes => dispatch(success(codes)),
        error => dispatch(failure(errorMessage(error)))
      );
  };

  function request() { return { type: GET_PROMO_CODES_REQUEST } }
  function success(codes) { return { type: GET_PROMO_CODES_SUCCESS, codes } }
  function failure(error) { return { type: GET_PROMO_CODES_FAILURE, error } }
}
